import { render } from "./CommitteeTable.vue?vue&type=template&id=f304364e&scoped=true&ts=true"
import script from "./CommitteeTable.ts?vue&type=script&lang=ts"
export * from "./CommitteeTable.ts?vue&type=script&lang=ts"

import "./CommitteeTable.scss?vue&type=style&index=0&id=f304364e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f304364e"]])

export default __exports__